import { s } from '@w/schema'
import { pageReadColumns, pageReadSchema } from '../db/page-read'
import type { FlashcardsDb } from '../router/flashcards-fe.router-ctx'
import type { Language, Lexeme } from '../lexicon/lexicon-model'

// Module scope (Zod: define schemas once): inline schemas paid construction on every call.
const memberTotalSchema = s.object({ id: s.string(), total: s.number() })

/** Select the displayed exemplar using scalars, then read its own document. */
export async function listAdoptedRuleMembers(
  db: FlashcardsDb,
  input: {
    workspaceId: string
    language: Language
    inflectionClass: string
    rep: number
  },
): Promise<{ members: Lexeme[]; rep: number; pageId?: string }> {
  const selected = await db.query`
    WITH members AS (
      SELECT ${db.pages.id}, row_number() OVER (ORDER BY ${db.pages.entryId}, ${db.pages.id}) - 1 AS position,
        count(*) OVER () AS total
      FROM ${db.pages}
      WHERE ${db.pages.kind.eq('lexiconEntry')} AND ${db.pages.entryKind.eq('lexeme')}
        AND ${db.pages.language.eq(input.language)} AND ${db.pages.inflectionClass.eq(input.inflectionClass)}
        AND ${db.pages.deletedAt.isNull()}
    )
    SELECT id, total FROM members WHERE position = ((${input.rep} % total) + total) % total
    LIMIT 1
  `.executeOne(memberTotalSchema)
  // No members: the rep passes through unchanged, so authored practice still rotates.
  if (!selected) return { members: [], rep: input.rep }
  const rows = await db.query`
    SELECT ${pageReadColumns(db.pages)} FROM ${db.pages}
    WHERE ${db.pages.id.eq(selected.id)} AND ${db.pages.deletedAt.isNull()}
  `.execute(pageReadSchema(input.workspaceId))
  const members = rows.flatMap(({ content }) => content.kind === 'lexiconEntry' && content.entry.kind === 'lexeme' ? [content.entry] : [])
  return { members, rep: Math.floor(input.rep / selected.total), pageId: selected.id }
}
